

<template>
  <div class="container">
    <!--  导航  -->
    <FansHeader class="FansHeader"
                nav-color="_black"
                logoColor="_black"
                currNavIdx="0"
    />

    <div class="head">
      <div class="inner_center">
        <h1 class="headline">
          我们深知在求知路上的辛苦与付出，<br>
          因此为你提供了学生专属福利！
        </h1>
        <div class="subhead">
          无论你是渴望畅游知识海洋的大学生，还是着迷于创意设计的艺术爱好者，<br>
          我们都为你们量身定制了超值优惠。
        </div>
      </div>

      <!-- 用户认证bar -->
      <div class="user-auth-bar" v-if="!eduCertificateStatus">
        <div class="inner_center">
          教育优惠：设计类相关专业提交信息，审核通过都可享受优惠价和授权服务。
          <span @click="showEduCertificateModal">提交认证信息></span>
        </div>
      </div>
    </div>
    <div class="main">
      <!-- 个人vip -->
      <div class="meal-item person" v-if="isShowPersonMeal">
        <div class="tag">教育优惠</div>
        <div class="meal-info">
          <div class="name">个人VIP</div>
          <div class="price-bpx">
            <i class="icon_dollar">¥</i>
            <div class="price">99</div>
            <div class="year">/1年
              <div class="old-price">原价99</div>
            </div>
          </div>
          <div class="down-num">个人下载10张/天</div>
        </div>
        <div class="meal-equity">
          <div class="content download">
            <div class="title">下载范围</div>
            <div class="down-scope">
              <div class="down-scope-item" v-for="item in PERSON_VIP.downScope">
                <i :class="[ 'iconfont', item.scope ? 'icon-gou3': 'icon-cha3' ]"/>
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="content accredit">
            <div class="title">授权范围</div>
            <div class="down-scope">
              <div class="down-scope-item"
                   :class="{ 'active': item.scope }"
                   v-for="item in PERSON_VIP.useScope">
                <i :class="[ 'iconfont', item.scope ? 'icon-gou': 'icon-cha2' ]"/>
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="pay-info">
          <PicPayQrCode class="PayQrCode payment-box"
                        :payment-data="paymentData"
                        :isCertificate="isCertificate"
          ></PicPayQrCode>
          <template v-if="eduCertificateStatus == false">
            <i class="mask1" @click="showEduCertificateModal">请先填写<br>认证信息</i>
            <i class="mask2" @click="showEduCertificateModal">请先填写<br>认证信息</i>
          </template>
        </div>

      </div>
      <!-- 升级vip -->
      <div class="meal-item upgrade">
        <div class="tag">教育优惠价 升级会员</div>
        <div class="meal-info">
          <div class="name">
            更多授权范围 <br>
            升级会员
          </div>
        </div>
        <div class="meal-equity">
          <div class="content download">
            <div class="title">下载范围</div>
            <div class="down-scope">
              <div class="down-scope-item" v-for="item in PERSON_VIP.downScope">
                <i class="iconfont icon-gou3"/>
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="content accredit">
            <div class="title">授权范围</div>
            <div class="down-scope">
              <div class="down-scope-item active"
                   v-for="item in PERSON_VIP.useScope">
                <i class="iconfont icon-gou"/>
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="service-info">
          <div class="contact-service">
            如需获取更多授权范围 <br>
            请联系在线客服
            <i class="icon_service"></i>
          </div>
          <a :href="SERVICE_LINK" target="_blank" class="service-btn">
            在线客服
          </a>
        </div>
      </div>

      <!-- 学生使用场景  -->
      <div class="student-use-scene">
        <div class="title">学生使用在什么场景？</div>
        <div class="scene-list"
        >
          <div class="scene-item"
               v-for="item in sceneList"
               :key="item.url">
            <img :src="item.url" alt="">
            <div class="scene-title">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 教育认证弹框 -->
    <ModalMiddle class="edu-certificate" v-if="isShowEduCertificateModal"
                 @close="isShowEduCertificateModal = false"
    >
      <div slot="ModalContent" class="ModalContent">
        <div class="title">请提交教育优惠信息</div>
        <div class="content">

          <div class="form">
            <el-form :model="ruleForm"
                     :rules="rules" ref="ruleForm">
              <el-form-item prop="name">
                <div class="label">姓名</div>
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>
              <el-form-item prop="speciality">
                <div class="label">专业</div>
                <el-input v-model="ruleForm.speciality"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <div class="label">手机号</div>
                <el-input v-model="ruleForm.phone"></el-input>
              </el-form-item>
              <el-form-item prop="image">
                <div class="label">上传教育证明</div>

                <div class="upload-img-item" v-for="(vo,idx) in imgList" :key="idx+'img'">
                  <!-- 默认 -->
                  <div class="default">
                    <!--                    <i class="iconfont2 icon-qy-add-line"></i>-->
                    <!--                    上传学信网截图/学生证照片-->
                  </div>
                  <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp,image/webp"
                         multiple="multiple" name="imput2"
                         @click="clickImg($event)"
                         @change="changeImg($event)">
                  <!--                    <img :src="vo" v-if="vo !='' " alt="">-->
                  图片预览
                  <el-image
                    class="el-image"
                    :src="vo"
                    :preview-src-list="imgList"/>

                  <div class="mask">
                    <i class="iconfont icon-trash" @click="removeImg(vo,idx)"></i>
                    <!--                <i class="iconfont icon-chaxun2"></i>-->
                  </div>
                </div>
                <div class="upload-img-item" v-if="imgList.length == 0">
                  <!-- 默认 -->
                  <div class="default">
                    <i class="iconfont2 icon-qy-add-line"></i>
                    上传学信网截图/学生证照片
                  </div>
                  <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image/bmp,image/webp"
                         multiple="multiple" name="imput2"
                         @click="clickImg($event)"
                         @change="changeImg($event)"
                  >
                </div>


              </el-form-item>
            </el-form>
            <div class="submit-btn" @click="submit">提交</div>
          </div>
          <div class="rules">
            <div class="title">活动细则</div>
            <div class="content">
              <p>
                1.提交信息后，管理员会在3个工作日内审核，审核不通过按原价折算VIP时长为3个月。
              </p>
              <p>
                2.在校学生提交学生证照片、学信网-学籍信息等截图（须包含入学日期、学籍状态），证明属于设计相关专业，提交成功可99元购个人VIP一年（10张/天），下载成功后虚拟商品不支持退款。
              </p>
              <p>
                3.个人VIP仅限个人学习交流使用，不可用于设计比赛等，版权归属潮国创意。
              </p>
              <p>
                4.在活动有效期内，设计类在校学生每年可享受一次优惠。
              </p>
              <p>
                5.潮国创意会严格保密您的个人信息，绝不外泄。如提供虚假信息，教育优惠VIP将被取消且不再享受网站任何服务。
              </p>
            </div>


          </div>
        </div>

      </div>
    </ModalMiddle>

    <div class="pay-success-modal">
      <ModalMiddle v-if="isShow"
                   @close="isShow = false"
      >
        <div slot="ModalContent" class="ModalContent">
          <i class="iconfont icon-gou"/>
          <div class="title">支付成功</div>

          <div class="btn-group">

            <div class="btn-item btn-watch" @click="navToUserCenter">去个人中心查看</div>
          </div>
        </div>
      </ModalMiddle>
    </div>
  </div>
</template>
<script>
import FansHeader from "@/components/fans/header/index.vue";
import {PERSON_VIP} from "@/constant/_Privately/Vip";
import {SERVICE_LINK, USER_CENTER_VIP_RECORD, USER_CENTER_VIP_RECORD_MULTIPLE} from "@/constant/_Public/Path";
import PicPayQrCode from "@/components/_Privately/Pic/PicPayQrCode/index.vue";
import {sceneList} from "@/pages/pay/edu/module";
import {fnLogin, fnPay} from "@/fn";
import axios from "axios";
import _ from 'lodash'
import {getCookie} from "@/utils/auth";
import {userEduCertification} from "@/api/user";
import {fnBasic} from "@/fn/_fn";

export default {
  name: "PayEdu",
  components: {PicPayQrCode, FansHeader},
  mounted() {
    this.init();
  },
  data() {
    // 手机号验证规则
    const validatePhone = (rule, value, callback) => {
      let reg = /^1\d{10}$/; // 手机号正则表达式1
      if (value === '') {
        callback(new Error('手机号不能为空'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      PERSON_VIP,
      SERVICE_LINK,
      paymentData: {
        isShowWft: false,
        zfbUrl: '',
        wxUrl: '',
      },
      isCertificate: true,
      eduCertificateStatus: false,
      isShowEduCertificateModal: false,
      sceneList,
      ruleForm: {
        name: '',
        speciality: '',
        phone: '',
        image: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        speciality: [
          {required: true, message: '请输入专业', trigger: 'blur'},
        ],
        phone: [
          {required: true, validator:validatePhone, trigger: 'blur'},
        ],
        image: [
          {required: true, message: '请上传学信网截图/学生证照片', trigger: 'change'},
        ],

      },
      timerList: [],
      imgList: [],
      imgSrc: "",
      isShow:false,
      isShowPersonMeal:true
    }
  },
  methods: {
    init() {
      this.buy();
    },
    showEduCertificateModal() {
      if(fnLogin.checkLogin()){
        this.isShowEduCertificateModal = true;
      }else{
        fnLogin.loginIntercept();
      }
    },
    async buy(vo, coupon_id) {
      if (fnLogin.checkLogin()) {
        this.timerList.forEach((item, index) => {
          clearInterval(item);
        })
        await fnPay.getPayCode(12, 1).then(res => {
          this.eduCertificateStatus = true;
          let {payment, ali_pay, wechat_pay} = res;
          this.paymentData = payment;
          this.countdown();
          this.getPayResult(ali_pay.order_no)
          this.getPayResult(wechat_pay.order_no)
        }).catch(err => {
          if (err.status == -4) {
            this.eduCertificateStatus = false;
          }else if (err.status == -5) {
            this.isShowPersonMeal = false;
            this.eduCertificateStatus = true;
          }
        })
      } else {
        this.$store.commit("user/SET_IS_SHOW_LOGIN", true);
      }
    },
    countdown() {
      let second = 5 * 60;
      let vm = setInterval(() => {
        second--;
        if (second < 1) {
          clearInterval(vm);
          clearInterval(this.timer);// 满足条件时 停止计时
          this.clearTimer();
        }
      }, 1000)
    },
    getPayResult(order_no) {
      this.timer = setInterval(() => {
        fnPay.getPayResult(order_no).then(res => {
          if (res.status === 1) {
            // this.checkVip(this.currentVipInfo)
            // this.vipFullName = this.currentVipInfo.LABEL;
            this.isShow = true;
            // this.init();
            clearInterval(this.timer);// 满足条件时 停止计时
            this.timerList.forEach((item, index) => {
              clearInterval(item);
            })
            this.timerList = [];
            this.timer = 0;
          }
        })
      }, 2000)
      this.timerList.push(this.timer)
    },
    clearTimer() {
      if (this.timer) {
        this.timerList.forEach((item, index) => {
          clearInterval(item);
        })
        this.timerList = [];
        this.timer = 0;
      }
    },

    removeImg(vo, idx) {
      this.imgList.splice(idx, 1);
      this.ruleForm.image = "";
    },
    clickImg(e) {
      /* 修复chrome */
      e.target.value = '';
    },
    changeImg(e) {
      //上传图片并预览
      console.log(e.target.files)


      this.Files = e.target.files;
      let fileList = e.target.files;
      console.log(Array.isArray(fileList))
      let _this = this;

      for (const item of fileList) {
        console.log(item)

        if ((item.size / 1024) > 2048) {
          alert("文件大小不能大于20M！");
          return false;
        }
        let img = new FileReader();
        img.readAsDataURL(item);
        console.log("img:", img)
        img.onload = ({target}) => {
          this.imgSrc = target.result; //将img转化为二进制数据
          console.log(target.result)
          _this.imgList.push(target.result)
        }

        let file = item;

        let request = new XMLHttpRequest();
        let formData = new FormData();
        var filename = file.name;
        /* 开始上传服务器 */
        /* 获取签名 */
        this.$.ajax({
          url: 'https://upload.chaopx.com/?m=UploadNew&a=createUrlPolicySign&provider=oss&__UPLOAD__=1', // 请求的URL
          method: 'GET', // 请求方法
          dataType: 'json', // 期望的响应数据类型
          xhrFields: {
            // withCredentials: true, // 添加这行、
          },
          headers: {
            'x-Secret': !!getCookie('user_uniq_id') ? getCookie('user_uniq_id').replace(/"/g, '') : ''
          },
          data: {filename: filename}, // 将数据对象转换为 JSON 字符串
          success: function (result) { // 请求成功时的回调函数
            console.log('Data received:', result);
            // 上传参数
            Object.entries(result['form_data']).forEach(([key, value]) => {
              formData.append(key, value);
            });
            // 文件流
            formData.append(result['form_name'], file);
            request.open('POST', result['form_url']);

            request.upload.onprogress = (evt) => {
              // progress(evt.lengthComputable, evt.loaded, evt.total);
              console.log({evt})
            };
            request.onload = function () {
              if (request.status >= 200 && request.status < 300) {
                // load(request.responseText);
                const data = JSON.parse(request.responseText);
                if (data) {
                  const size = parseInt(data.file_size);
                  const width = parseInt(data["image-width"]);
                  const height = parseInt(data["image-height"]);
                  _this.ruleForm.image = 'https://pic-oss.chaopx.com/' + data.url;
                  _this.$refs["ruleForm"].clearValidate('image');
                } else {
                  if (data.hasOwnProperty('msg')) {
                    _this.$myNotify.show(data.msg)
                  }
                }
              } else {
                // error('error');
              }
            };
            request.send(formData);
            return {
              abort: () => {
                request.abort();
                // abort();
              }
            };
          },
          error: function (xhr, status, error) { // 请求失败时的回调函数
            console.error('Request error:', error);
          }
        });
      }
    },

    submit: _.throttle(function (n, o) {
      this.$refs["ruleForm"].validate((valid) => {
        console.log(this.ruleForm)

        if (valid) {
          // 校验通过
          console.log('校验通过')
          userEduCertification(this.ruleForm).then(res =>{
            const { status,data,message } = res;
            console.log({
              res
            })
            if (status == 200){
              this.$myNotify.success("填写成功",()=>{
                this.isShowEduCertificateModal = false;
                this.buy();
              });
            }else{
              this.$myNotify.show(message);
            }
          })

        }
        /*else {
          // 校验不通过
          // 使用$nextTick的原因是，错误提示的元素是在视图更新后出现的，不使用$nextTick获取元素是undefined
          this.$nextTick(() => {
            // 获取第一个校验错误的元素
            const element = document.querySelectorAll('.el-form-item__error')[0]
            // 滚动到错误元素对应位置
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })

          });
          return false;
        }*/
      });
    }, 3000),
    navToUserCenter() {
      this.isShow = false;
      fnBasic.navigationTo(USER_CENTER_VIP_RECORD);
    },
  }

}
</script>
<style scoped lang="scss">
@import "index";
</style>
